<template>
  <div class="portal-box">
    <img src="../assets/a.svg" alt="description" class="img-box" />
    <div class="content-wrap">
      <div class="txt-portal">
        <span v-if="loading" class="spinner"></span>
        {{ message }}
      </div>
    </div>
  </div>
</template>
<script>
import { accountCheck } from '/src/api/quickBiLogin'
import dd from 'dingtalk-jsapi'

export default {
  name: 'QuickBiLogin',
  data() {
    return {
      message: '',
      redirect_url: '',
      params: '',
      flag: false,
      loading: false,
    }
  },
  created() {
    if (!this.dDingJudgeEnvPlatform()) {
      const that = this
      const corpId = 'dingddd105713596751f35c2f4657eb6378f'
      dd.runtime.permission.requestAuthCode({
        corpId: corpId,
        onSuccess: function (info) {
          const code = info.code
          that.handleLogin(code)
        },
        onFail: function (err) {
          that.$message.warning(err.errorMessage + ' 请联系管理员')
        }
      })
    }

  },
  methods: {
    async handleLogin(code) {
      this.message = '正在检查Quick BI账号状态'
      this.loading = true
      accountCheck({ code }).then(res => {
        this.toQuickBi()
      }).catch(err => {
        this.toQuickBi()
      }).finally(() => {
        this.loading = false
      })
    },
    toQuickBi() {
      dd.navigateToPage({
        url: 'https://bi.aliyun.com',
        success: () => { },
        fail: () => { },
        complete: () => { },
      });
    },

    dDingJudgeEnvPlatform() {
      let that = this
      if (dd.env.platform === 'notInDingTalk') {
        that.message = '请在钉钉工作台中打开'
        return false
      }
    }
  }
}
</script>
<style scoped>
body,
html {
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  background-color: #f0f0f0;
  font-family: 'Arial', sans-serif;
}

#centered-heading {
  text-align: center;
  color: #333;
  font-size: 2.5em;
  padding: 20px;
  border: 2px solid #333;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  max-width: 80%;
}

.portal-box {
  height: 100%;
}

.img-box {
  width: 100%;
  height: 100%;
}

.txt-portal {
  font-size: 28px;
  text-align: center;
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
}

.content-wrap {
  position: fixed;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}

.tip-b-box {
  font-size: 18px;
}

@media screen and (max-width: 1024px) {

  .txt-portal,
  .tip-b-box {
    font-size: 14px;
  }
}

.spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 2px solid #c0c4cc;
  /* 边框灰色 */
  border-top-color: #409eff;
  /* 顶部为主题色 */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
